import { privateApi } from '@configs/axios-instances';
import { MegaphoneNetworkType } from '@account_module/types/Onboarding';

type GetMegaphoneNetworksType = {
  organization_id: string | null;
  token: string | null;
};

export type GetNetworkShowsType = {
  network_id: string;
  token: string | null;
};

/**
 * Fetch Megaphone networks
 * @param {GetMegaphoneNetworksType} params
 * @return {Promise<MegaphoneNetworkType[]>}
 */

export const getMegaphoneNetworks = async (
  params: GetMegaphoneNetworksType
): Promise<MegaphoneNetworkType[]> => {
  const { data } = await privateApi.get('/megaphone/networks/', { params });
  return data;
};

/**
 * Verify Megaphone credentials
 * There is currently no endpoint for megaphone credentials verification.
 * Therefore we use the /networks endpoint only to check if the response is successful, which implies that the credentials are correct.
 * @param {GetMegaphoneNetworksType} params
 * @return {Promise<{isVerified: boolean, error: any}>}
 */

export const verifyMegaphoneCredentials = async (
  params: GetMegaphoneNetworksType
): Promise<{
  isVerified: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
}> => {
  let isVerified = false as boolean;
  let error = null;

  try {
    const res = await privateApi.get('/megaphone/networks/', { params });
    isVerified = res ? true : false;
  } catch (err) {
    error = err;
  }

  return { isVerified, error };
};

/**
 * Fetch Megaphone shows by network id
 * @param {GetNetworkShowsType} params
 * @return {Promise<any>}
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getNetworkShows = async (params: GetNetworkShowsType): Promise<any> => {
  const { network_id } = params;

  if (!network_id) return;

  const { data } = await privateApi.get('/megaphone/shows/', { params });
  return data;
};
